import { C } from '../../constants/theme';

export const bookInputStyle = {
  width: '100%', height: 44,
  border: `1.5px solid ${C.border}`, borderRadius: 10,
  padding: '0 14px', fontSize: '0.875rem',
  fontFamily: 'Meshkat, sans-serif',
  color: C.textPrimary, outline: 'none',
  boxSizing: 'border-box', transition: 'border-color 0.18s',
  display: 'block', background: 'white',
};

export const dropdownWrap = { position: 'relative', display: 'inline-flex', alignItems: 'center' };

export const dropdownStyle = {
  height: 40, border: `1.5px solid ${C.border}`, borderRadius: 10,
  paddingInlineEnd: 12, paddingInlineStart: 30,
  fontSize: '0.875rem', fontFamily: 'Meshkat, sans-serif',
  color: C.textPrimary, outline: 'none', background: 'white',
  cursor: 'pointer', appearance: 'none', WebkitAppearance: 'none',
};
